/**
 * Utility functions for media URL handling
 * Solves CORS issues and ensures audio/video works across all browsers/regions
 */

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Convert external media URLs to use the backend proxy
 * This solves CORS issues and ensures compatibility in all US browsers
 */
export const getMediaUrl = (url) => {
  if (!url) return null;
  
  // If it's an internal URL, use it directly
  if (url.startsWith('/api/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  
  // If it's already a full URL from external source, use the proxy
  if (url.startsWith('http')) {
    // For customer-assets URLs, use the proxy
    if (url.includes('customer-assets.emergentagent.com') || 
        url.includes('customer-assets-cm19k8pv.emergentagent.net')) {
      return `${API}/media/proxy?url=${encodeURIComponent(url)}`;
    }
    return url;
  }
  
  return url;
};

/**
 * Get direct URL (for downloads that shouldn't use proxy)
 */
export const getDirectUrl = (url) => {
  if (!url) return null;
  
  if (url.startsWith('/api/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  
  return url;
};

export const getDownloadUrl = (url, filename) => {
  if (!url) return null;
  const name = encodeURIComponent(filename);
  if (url.startsWith('/api/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}?download=${name}`;
  }
  if (url.includes('customer-assets')) {
    return `${API}/media/proxy?url=${encodeURIComponent(url)}&download=${name}`;
  }
  return url;
};
